import {contractApi} from "@/axios";
//通用api
//登录
export function login(data) {
    return contractApi({
        url: '/login',
        method: 'post',
        data: data
    })
}
//登出
export function logout() {
    return contractApi({
        url: '/logout',
        method: 'get'
    })
}
//刷新用户信息
export function flush() {
    return contractApi({
        url: '/flushed-user',
        method: 'get'
    })
}
